<template>
  <TableLayout :permissions="['system:user:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="登录账号" prop="username">
        <el-input v-model="searchForm.username" v-trim placeholder="请输入登录账号" @keypress.enter.native="search"/>
      </el-form-item>
      <el-form-item label="企业名称" prop="companyName">
        <el-input v-model="searchForm.companyName" v-trim placeholder="请输入企业名称" @keypress.enter.native="search"/>
      </el-form-item>
      <el-form-item label="社会信用代码" prop="creditCode">
        <el-input v-model="searchForm.creditCode" v-trim placeholder="请输入社会信用代码" @keypress.enter.native="search"/>
      </el-form-item>
      <el-form-item label="所属省份" prop="provinceId">
        <div style="display:flex">
          <el-select v-model="searchForm.provinceId" placeholder="请选择省份" @change="selectProvince">
            <el-option
              v-for="item in province"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="所属城市" prop="cityId">
        <el-select v-model="searchForm.cityId" placeholder="请选择城市">
          <el-option
            v-for="item in cities"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <section>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li v-permissions="['system:user:create']"><el-button icon="el-icon-plus" type="primary" @click="$refs.operaServeUserWindow.open('新建用户')">新建</el-button></li>
        <li><el-button type="primary" @click="resetUserPwd">重置密码</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="username" label="登录账号" align="center" min-width="140px" fixed="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="服务机构名称" align="center" min-width="140px" fixed="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creditCode" label="社会信用代码" align="center" min-width="130px"></el-table-column>
        <el-table-column prop="address" label="所属区域" align="center" min-width="140px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalPerson" label="法定代表人" align="center" min-width="100px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="linkName" label="联系人" align="center" min-width="100px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="linkPhone" label="手机号" align="center" min-width="120px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile" label="状态" align="center" min-width="120px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#999"
              :active-value="0"
              :inactive-value="1"
              @change="changeStatus(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="140px"></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="160"
          fixed="right"
        >
        <!-- v-if="isAdmin || (row.id !== userInfo.id && row.roles.findIndex(r => r.code === adminCode) === -1)"  -->
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.childrenListWindow.open(`${row.username}的子账号`, { companyId:row.companyId, type: 3})">查看子账号</el-button>
            <el-button type="text" @click="$refs.operaServeUserWindow.open('编辑', row)">编辑</el-button>
            <el-button type="text" @click="companyDetail(row.companyId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      ></pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaServeUserWindow ref="operaServeUserWindow" @success="handlePageChange(tableData.pagination.pageIndex)"/>
    <OperaCompanyUserWindow ref="operaCompanyUserWindow" @success="handlePageChange(tableData.pagination.pageIndex)"/>
    <!-- 子账号 -->
    <ChildrenListWindow ref="childrenListWindow" />
  </TableLayout>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import TableLayout from '@/layouts/TableLayout'
import BaseTable from '@/components/base/BaseTable'
import OperaServeUserWindow from '@/components/business/user/OperaServeUserWindow'
import ChildrenListWindow from '@/components/business/user/ChildrenListWindow'
import OperaCompanyUserWindow from '@/components/business/user/OperaCompanyUserWindow'
import { treeList } from '@/api/business/areas'
import { queryCompanyDetail } from '@/api/business/company'
import { resetPwd, changeStatus } from '@/api/business/account'

export default {
  name: 'SystemUser',
  extends: BaseTable,
  components: { OperaServeUserWindow, ChildrenListWindow, TableLayout, Pagination, OperaCompanyUserWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        username: '',
        companyName: '',
        provinceId: '',
        cityId: null, 
        areaId: null,
        type: '2' //服务机构
      },
      province: [],
      cities: []
    }
  },
  provide() {
    return {
      province: () => this.province
    }
  },
  created () {
    this.config({
      module: '用户',
      api: '/business/account',
      'field.main': 'realname',
      sorts: [{
        property: 'CREATE_TIME',
        direction: 'DESC'
      }]
    })
    // 地区
    treeList({ type: 0 })
      .then(res => {
        // console.log(res)
        this.province = res
      })
      .catch(e => {
        this.$message.error(e)
      })
    this.search()
  },
  methods: {
    changeStatus({id, status}) {
      changeStatus({ id, value:status })
        .then(res => {
          this.$message.success('修改成功')
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.handlePageChange()
        })
    },
    // 选择省份
    selectProvince(val) {
      this.cities = []
      this.areas = []
      this.searchForm.cityId = ''
      this.searchForm.areaId = ''
      treeList({ type: 1, parentId: val })
        .then(res => {
          this.cities = res
         
        })
      // const tempProvince = this.province.find(item => item.id === val)
      // if (tempProvince) {
      //   this.cities = tempProvince.childList
      // }
    },
    companyDetail(id) {
      queryCompanyDetail(id)
        .then(res => {
          console.log(res)
          this.$refs.operaCompanyUserWindow.open('企业详情', res)
        })
        .catch(() => {
          this.$message.error('获取详情错误')
        })
    },
    resetUserPwd() {
      if (this.tableData.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      let message = `确认重置已选中的 ${this.tableData.selectedRows.length} 个账号密码吗?`
      this.$dialog.resetConfirm(message)
        .then(() => {
          this.isWorking.delete = true
          resetPwd({ ids: this.tableData.selectedRows.map(row => row.id).join(',') })
            .then(() => {
              this.$message.success('重置成功')
              this.handlePageChange()
            })
            .catch(e => {
              this.$message.error(e)
            })
            .finally(() => {
              this.isWorking.delete = false
            })
        })
        .catch(() => {})
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/style/variables.scss";
// 列表头像处理
.table-column-avatar {
  img {
    width: 48px;
  }
}
</style>
